import React, { useEffect, useState } from 'react';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton,InstapaperShareButton, FacebookIcon, WhatsappIcon, LinkedinIcon, TwitterIcon } from "react-share";
import css from './SocialShare.module.css';
import IconCard from '../SavedCardDetails/IconCard/IconCard';

const SocialShare = props => {
  const {
    displayName,
    isListing,
    listingID,
    slug,
    userID,
  } = props;

  const [copyText, setCopyText] = useState(false);

  useEffect(() => {
    if (!copyText) return;
    const timer = setTimeout(() => {
      setCopyText(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [copyText]);

  const displayTitle = isListing ? `Share @${displayName}` : `Share @${displayName}`;
  // Resolve a valid absolute base URL for sharing
  const origin = (process.env.REACT_APP_MARKETPLACE_ROOT_URL || '');
  const listingUrl = `${origin}/l/${slug || ''}/${listingID || ''}`;
  const userUrl = `${origin}/u/${userID || ''}`;
  // Prefer explicit url prop if provided
  const shareUrl = (isListing ? listingUrl : userUrl);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopyText(true);
    });
  };

  return (
    <div className={css.shareModalWrapper}>
      <h4 className={css.modalTitle}>{displayTitle}</h4>
      <ul className={css.socialLinks}>
        <li>
          <FacebookShareButton
            url={shareUrl}
            quote={displayTitle}
            className={css.facebookButton}
          >
          <FacebookIcon size={40} round />
          </FacebookShareButton>
        </li>
        <li>
          <WhatsappShareButton
            url={shareUrl}
            title={displayTitle}
            className={css.linkedinButton}>
            <WhatsappIcon size={40} round />
          </WhatsappShareButton>
        </li>
        <li>
          <LinkedinShareButton
            url={shareUrl}
            className={css.linkedinButton}>
            <LinkedinIcon size={40} round />
          </LinkedinShareButton>
        </li>
        <li>
          <TwitterShareButton
            url={shareUrl}
            title={displayTitle}
            className={css.linkedinButton}>
            <TwitterIcon size={40} round />
          </TwitterShareButton>
        </li>

        {/* Copy Link button */}
        <li>
          <button
            type="button"
            onClick={handleCopy}
            className={css.copyButton}
          >
            <IconCard type="link" />
          {copyText && <span className={css.copiedText}>Link copied!</span>}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default SocialShare;
